import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { BaseService } from '../../../../../services/base.service';
import { IntegrationService } from '../../../../../services/integration.service';
import { FormGroup } from '@angular/forms';
import { environment } from '../../../../../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { ChannelComponent } from '../../../../../dialogs/channel/channel.component';
import { NotificationService } from '../../../../../services/notifications.service';
import { WebSocketService } from '../../../../../services/gateway.service';
import { DialogService } from '../../../../../services/dialog.service';
import { ModalService } from '../../../../../services/modal.service';
import { ChannelService } from '../../../../../services/channel.service';
import {
  CHANNEL_STATUS,
  CHANNEL_STATUS_OBJECT,
  CHANNEL_TYPE,
  DEFAULT_ERROR,
  ERROR_MESSAGES,
  NAME_PROJECT,
  ACTIVE_EMPLOYEES_PARAMS,
} from '../../../../../enum/constants';
import { IError } from '../../../../../interfaces';
import { Subject, takeUntil } from 'rxjs';
import { CrmService } from '../../../../../services/crm.service';
import { TranslateService } from '@ngx-translate/core';
import { formatFullName } from '../../../../../helpers';

interface IFormReply {
  replies: any;
}

@Component({
  selector: 'app-integration-olx',
  templateUrl: './integration-olx.component.html',
  styleUrls: ['./integration-olx.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class IntegrationOlxComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<null>();

  constructor(
    private readonly dialog: MatDialog,
    private readonly crmService: CrmService,
    private readonly modalService: ModalService,
    private readonly translate: TranslateService,
    private readonly dialogService: DialogService,
    private readonly channelService: ChannelService,
    private readonly webSocketService: WebSocketService,
    private readonly integrationService: IntegrationService,
    private readonly notificationService: NotificationService,
    protected readonly baseService: BaseService,
  ) {}

  @Input() payload: any;
  @Output() close = new EventEmitter<any>();

  protected readonly NAME_PROJECT = NAME_PROJECT;
  protected readonly environment = environment;

  channel_id!: string;
  channel_name!: string;
  account: any = {};
  integration!: any;
  is_empty: boolean = false;
  is_expired: boolean = false;
  is_pause: boolean = false;
  status: CHANNEL_STATUS = CHANNEL_STATUS.LOADING;

  error!: string;

  form!: FormGroup;
  formReply!: FormGroup<IFormReply>;
  channels: any[] = [];
  channel: any;

  public isLoader: boolean = false;
  public managersList: any[] = [];
  public managersListInfo: any = {};
  public searchedManager = '';
  public managerPage = 1;

  ngOnInit() {
    this.channel_id = this.payload.channel.id;
    this.channel_name = this.payload.channel.name;

    this.webSocketService
      .onSendStatusOlx(this.channel_id)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: CHANNEL_STATUS) => {
        if (data === CHANNEL_STATUS.SYNCING) {
          this.notificationService.showSuccess(
            this.translate.instant('notifications_texts.success.success'),
            this.translate.instant('notifications_texts.success.successfully_reconnected'),
          );
        }
        if (data === CHANNEL_STATUS.CONNECTED) {
          this.notificationService.showSuccess(
            this.translate.instant('notifications_texts.success.success'),
            this.translate.instant('notifications_texts.success.successfully_synced'),
          );
        }
        this.isLoader = false;
        this.init();
      });

    this.webSocketService
      .onErrorOlx(this.channel_id)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.isLoader = false;
        if (res === 'MAX_INTEGRATION') {
          this.modalService.openTariffUpdate();
          this.notificationService.showError('', ERROR_MESSAGES[res].replace('{0}', 'OLX'));
        } else if (ERROR_MESSAGES[res]) {
          this.notificationService.showError('', ERROR_MESSAGES[res]);
        } else {
          this.notificationService.showError('', res);
        }
      });

    this.init();
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
    this.webSocketService.offErrorOlx(this.channel_id);
  }

  init() {
    this.isLoader = true;
    this.is_expired = false;
    this.integrationService
      .getOlxIntegration(this.channel_id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.is_empty = false;
          this.account = res.account || {};
          this.isLoader = false;
        },
        error: (res) => {
          this.isLoader = false;
          (res?.error?.errors || []).map((err: IError) => {
            if (err.code === 'INTEGRATION_NOT_FOUND') {
              this.is_empty = true;
              // this.webSocketService.onSuccessOlx(this.channel_id)
              //   .pipe(takeUntil(this.destroy$))
              //   .subscribe(() => {
              //     this.isLoader = false;
              //     this.init();
              //   });
              // this.webSocketService.onErrorOlx(this.channel_id)
              //   .pipe(takeUntil(this.destroy$))
              //   .subscribe(res => {
              //     this.isLoader = false;
              //     if (res === 'MAX_INTEGRATION') {
              //       this.modalService.openTariffUpdate();
              //       this.notificationService.showError('', ERROR_MESSAGES[res].replace('{0}', 'OLX'));
              //     } else if (ERROR_MESSAGES[res]) {
              //       this.notificationService.showError('', ERROR_MESSAGES[res]);
              //     } else {
              //       this.notificationService.showError('', res);
              //     }
              //   });
            }
          });
        },
      });

    this.channelService
      .getChannelById(this.channel_id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (channel) => {
          this.channel = channel;
          this.status = channel.status;
          this.is_expired = channel.status === 'EXPIRED';
          this.is_pause = channel.status === 'PAUSED';
        },
        error: (e): void => {
          (e.error?.errors || []).forEach((err: IError) => {
            console.log(ERROR_MESSAGES[err.code]);
          });
        },
      });

    this.integrationService
      .getChannels()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.channels = data;
        },
        error: (e): void => {
          (e.error?.errors || []).forEach((err: IError) => {
            console.log(ERROR_MESSAGES[err.code]);
          });
        },
      });

    this.onGetAllManagers();
  }

  onChangeChannel(event: any) {
    this.webSocketService.offErrorOlx(this.channel_id);
    this.webSocketService.offSuccessOlx(this.channel_id);
    this.channel_id = event.id;
    this.account = {};
    this.init();
  }

  openDialogUpdateChannel(): void {
    const dialogRef = this.dialog.open(ChannelComponent, {
      data: { channel: this.channels.find((v) => v.id === this.channel_id).name },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.integrationService.updateChannel(this.channel_id, result).subscribe({
          next: () => {
            this.init();
          },
          error: (e): void => {
            (e.error?.errors || []).forEach((err: IError) => {
              console.log(ERROR_MESSAGES[err.code]);
            });
          },
        });
      }
    });
  }

  disconnectAccount() {
    const dialogRef = this.dialogService.openConfirm({
      text: 'dialogs.integration-olx_1',
    });
    dialogRef.subscribe((result) => {
      if (result) {
        this.integrationService.disconnectOlx(this.channel_id).subscribe({
          next: () => {
            this.init();
          },
          error: (e) => {
            this.error = e?.error?.errors[0].message;
            (e.error?.errors || []).forEach((err: IError) => {
              console.log(ERROR_MESSAGES[err.code]);
            });
          },
        });
      }
    });
  }

  refreshAccount() {
    this.channelService.checkConnect({ type: CHANNEL_TYPE.OLX }).subscribe({
      next: (data: any) => {
        if (data) {
          const dialogRef = this.dialogService.openConfirm({
            text: 'check_connect_correct_account',
          });

          dialogRef.subscribe((result) => {
            if (result) {
              this.error = '';
              const url = new URL(environment.olx.url_ua + '/oauth/authorize');
              const company = this.baseService.getCompanyObj();
              url.searchParams.set('client_id', environment.olx.client_id);
              url.searchParams.set('scope', 'v2 read write');
              url.searchParams.set('response_type', 'code');
              url.searchParams.set('redirect_uri', environment.olx.callback_refresh);
              url.searchParams.set(
                'state',
                [
                  `user_id:${this.baseService.currentUserInfo.id}`,
                  `channel_id:${this.channel_id}`,
                  `company_id:${company.id}`,
                ].join('|'),
              );
              const windowFeatures = 'left=100,top=100,width=400,height=600';
              const newWindow = window.open(url, '_blank', windowFeatures);
              if (newWindow) newWindow.focus();
            }
          });
        }
      },
    });
  }

  connectAccount(): void {
    this.channelService.checkConnect({ type: CHANNEL_TYPE.OLX }).subscribe({
      next: (data: any) => {
        if (data) {
          this.isLoader = true;
          const url = new URL(environment.olx.url_ua + '/oauth/authorize');
          const company = this.baseService.getCompanyObj();
          url.searchParams.set('client_id', environment.olx.client_id);
          url.searchParams.set('scope', 'v2 read write');
          url.searchParams.set('response_type', 'code');
          url.searchParams.set('redirect_uri', environment.olx.callback_auth);
          url.searchParams.set(
            'state',
            [
              `user_id:${this.baseService.currentUserInfo.id}`,
              `channel_id:${this.channel_id}`,
              `company_id:${company.id}`,
            ].join('|'),
          );
          const windowFeatures = 'left=100,top=100,width=400,height=600';
          const newWindow = window.open(url, '_blank', windowFeatures);
          if (newWindow) newWindow.focus();
        }
      },
    });
  }

  deleteChannel() {
    const dialogRef = this.dialogService.openConfirm({
      text: 'dialogs.integration-olx_2',
    });
    dialogRef.subscribe((result) => {
      if (result) {
        this.channelService.delete(this.channel_id).subscribe({
          next: () => {
            this.init();
            this.close.emit('success');
          },
          error: (e) => {
            (e?.error?.errors || []).map(({ message }: any) => {
              this.notificationService.showError('', message);
            });
          },
        });
      }
    });
  }

  public onGetAllManagers(isInit: boolean = true): void {
    const params = { search: this.searchedManager, take: 25, page: this.managerPage, ...ACTIVE_EMPLOYEES_PARAMS };
    this.crmService
      .getAllManagers(params)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (v) => {
          this.managersListInfo = {
            page: v.page,
            size: v.size,
            total: v.total,
          };
          if (isInit || !!this.searchedManager) this.managersList = this.onParseFullname(v.items);
          else this.managersList = [...this.managersList, ...this.onParseFullname(v.items)];
        },
        error: (e) => {
          console.log(e);
        },
      });
  }

  private onParseFullname(arr: any[]): any[] {
    return arr.map((s: any) => {
      return { ...s, name: formatFullName(s.first_name, s.last_name) };
    });
  }

  public onScrollToEndManagers() {
    if (this.managersListInfo.page * this.managersListInfo.size < this.managersListInfo.total) {
      ++this.managerPage;
      this.onGetAllManagers(false);
    }
  }

  public onSearchManager(e: any): void {
    this.searchedManager = e?.term || '';
    this.onGetAllManagers(false);
  }

  public onCloseDropdown() {
    this.searchedManager = '';
    this.managerPage = 1;
    this.onGetAllManagers();
  }

  protected readonly CHANNEL_STATUS = CHANNEL_STATUS;
  protected readonly CHANNEL_STATUS_OBJECT = CHANNEL_STATUS_OBJECT;
}
